module.exports = __webpack_public_path__ + "static/media/IconSignuptick.00248cda.svg";